module.exports = __webpack_public_path__ + "img/4-JHW.222f63c.png";